import PropTypes from 'prop-types';
import React from 'react';

import Icon from '../icon/Icon';

require('./style.scss');

const Loader = props =>
  props.open ?
    <div className="loader">
      <div className="loader-spinner"><Icon name="spinner" /></div>
    </div> : null;

Loader.propTypes = {
  open: PropTypes.bool,
};

module.exports = Loader;



// WEBPACK FOOTER //
// ./app/components/common/loader/Loader.jsx